module.exports = require("!!vue-loader!../../../node_modules/vue-markdown-loader/_cache/research-2.vue");


//////////////////
// WEBPACK FOOTER
// ./src/assets/md/research.md
// module id = 215
// module chunks = 0